import React from 'react';
import { styled } from '@linaria/react';
import { Brand } from '@daedalus/core/src/brand/types';
import { useDeviceLayout } from '../../../context/deviceLayout';
import { NoStyleLink } from '../helpers/NoStyleLink';
import { Icon } from '../Icon';
interface Props {
  brand: Brand;
}
export const SocialMediaLinks = /*#__PURE__*/styled('div')({
  name: "SocialMediaLinks",
  class: "sjjvkan",
  propsAsIs: false
});
export const SocialMediaLinksWidget = ({
  brand
}: Props) => {
  const {
    isMobile
  } = useDeviceLayout();
  return <SocialMediaLinks>
      <NoStyleLink href={brand.socials?.facebookUrl} target="_blank" title="Facebook">
        <Icon name="Facebook" size={isMobile ? 'sm' : 'md'} />
      </NoStyleLink>
      <NoStyleLink href={brand.socials?.linkedinUrl} target="_blank" title="Linkedin">
        <Icon name="Linkedin" size={isMobile ? 'sm' : 'md'} />
      </NoStyleLink>
    </SocialMediaLinks>;
};

require("./SocialMediaLinksWidget.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SocialMediaLinksWidget.tsx");